export default {
    data() {
        return {
            transactionTypes: [
                {
                    text: 'واریز',
                    value: 'd'
                },
                {
                    text: 'برداشت',
                    value: 'w'
                },

            ]
        }
    },
}